import React from 'react';
import PageMeta from '../utils/PageMeta';
import EmptyState from '../components/EmptyState';
import * as styles from './NotFoundView.module.scss';

interface NotFoundViewProps
  extends Partial<React.ComponentProps<typeof EmptyState>> {
  documentTitle?: string;
}

const NotFoundView = ({
  documentTitle = 'Not Found - Slab',
  ...props
}: NotFoundViewProps) => (
  <div id="content" className={styles.container}>
    <PageMeta title={documentTitle} />
    <EmptyState
      imageName="notFound"
      title="Oh no! The knowledge you seek is nowhere to be found."
      {...props}
    />
  </div>
);

export default NotFoundView;
